import React, { useEffect, useRef } from 'react'

interface IProps {
  title?: string,
  visible: boolean,
  setVisible: (bl: boolean) => void,
  children: JSX.Element | JSX.Element[],
}

export function DrowerBottom({ title, visible, setVisible, children }: IProps) {
  const drower: any = useRef()
  const contDrower: any = useRef()

  useEffect(() => {
    toggle(visible)
  }, [visible])

  function toggle(val: any) {
    if (window.innerWidth < 767) {
      const body = document.getElementsByTagName("body")[0];
      if (val) {
        body.style.touchAction = "none";
        body.style.width = "100%";
        body.style.overflow = "hidden";
      } else {
        body.style.touchAction = "unset";
        body.style.width = "unset";
        body.style.overflow = "auto";
      }
    }
  }


  const handelClose = () => {
    window.addEventListener('click', function (e: any) {
      if (drower?.current != null && contDrower?.current != null) {
        if (drower.current!.contains(e.target)) {
          if (!contDrower.current!.contains(e.target)) {
            setVisible(false)
          }
        }
      }
    });
  }

  useEffect(() => {
    handelClose()
  }, [])

  return (
    <>
      <div ref={drower} className={`  ${visible == true ? 'drowerBottom-active' : 'drowerBottom'}`}>
        <div ref={contDrower} className="drowerBottom-cont">
          {children}
        </div>
      </div>
    </>
  )
}